export default __webpack_public_path__ + "static/app-features-3--mobile-61f2f851634d34e4de4c7da4ead885b3.png";